import styled from 'styled-components'

export const AppContainer = styled.div`
    text-align: center;
    margin: auto;
    max-width: 800px;
    position: relative;
`